import script from "./TextCustomizer.vue?vue&type=script&setup=true&lang=js"
export * from "./TextCustomizer.vue?vue&type=script&setup=true&lang=js"

import "./TextCustomizer.vue?vue&type=style&index=0&id=268587c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-268587c4"]])

export default __exports__